import { toLocalStorage } from "kanopi-components/utils/browser";
import { useGlobal } from "kanopi-components/useGlobal";

import { $, setBearer } from "kw/api";
import { useAPI } from "kw/api/useAPI";
import { userFields } from "kw/api/fragments";
import { handleErrorDisplay } from "kw/util/utils";

export function useRegister() {
  const [, setAuth] = useGlobal("auth");
  const { mutation, loading } = useAPI();
  const register = (values, isPasswordLess = false, onRegisterDone?) => {
    const registerUserMutation = {
      registerUser: [
        {
          email: $("email", "String!"),
          password1: $("password1", "String!"),
          password2: $("password2", "String!"),
        },
        {
          token: true,
          user: userFields,
        },
      ],
    };
    const registerPasswordLessUserMutation = {
      registerPasswordLessUser: [
        {
          email: $("email", "String!"),
        },
        {
          token: true,
          user: userFields,
        },
      ],
    };
    mutation(
      isPasswordLess ? registerPasswordLessUserMutation : registerUserMutation,
      (response) => {
        const responseUser = isPasswordLess
          ? response?.registerPasswordLessUser
          : response?.registerUser;
        setAuth(responseUser);
        setBearer(responseUser?.token);
        toLocalStorage("auth", responseUser);
        onRegisterDone?.();
      },
      {
        ...values,
      },
      (errors) => {
        let emailError =
          errors?.response?.errors &&
          errors?.response?.errors[0]?.message &&
          errors?.response?.errors[0]?.message;
        emailError = emailError && JSON.parse(emailError.replaceAll("'", '"'));

        if (emailError?.email.length > 0 && emailError.email[0]?.message) {
          handleErrorDisplay(emailError.email[0], emailError.email[0]?.message);
        } else {
          handleErrorDisplay(errors);
        }
      }
    );
  };
  return { register, loading };
}
